//
//
//
//
//
//

export default {
  props: {
    isActiveSlide: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  provide() {
    return {
      isActiveSlide: () => this.isActiveSlide,
    }
  },
}
